module.exports = __webpack_public_path__ + "static/augmented-reality-virtual-reality-a1dbe898fc31d05c258b39bed1ef4391.jpg";